/// ----------------------------------------------------------------------------------------
///Copyright (C) 2017 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>logout.component.ts</name>
///
/// <description>
///     Logout overlay
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>24 Mar 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 24Mar16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Component,OnInit, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/primeng';
import { HydUser } from '../../models/user';
import { LogService } from '../../services/log.service';
import { TranslatedStringsService } from '../../services/language.service';
import { MediatorService } from '../../services/mediator.service';
import { MediatorEventLookup } from '../../services/mediator-event-lookup.service';
import { UserAPIService, AppRole } from '../../services/Crestron.HydrogenAPI.UserApi.service';

@Component({
    selector: 'logout',
    templateUrl: './logout.component.html'
})
export class hydLogoutComponent implements OnInit{

    private userName: string = "";
    private userId: string = "";
    private role: string = "";
    private signOut : string = "";
    private appRoles : Array<AppRole>;    

    @ViewChild('logoutOverlay')
    logoutOverlay: OverlayPanel;  

    constructor(
        private hydUser: HydUser,
        private log:LogService,
        private i18n: TranslatedStringsService,
        private mediator: MediatorService,
        private userAPIService : UserAPIService
    ) {}

    public ngOnInit() {

        this.mediator.Event(MediatorEventLookup.LogoutDialogToggle).subscribe(
            event => {
                this.signOut = this.i18n.translate('header-signout');
                this.logoutOverlay.toggle(event);
            }
        );

        if (this.hydUser.UserId == null) {
            this.hydUser.AuthenticationObservable.subscribe(user => {
                this.getUserRole();
                this.setUserInfo();   
            });
        } else {
            this.getUserRole();
            this.setUserInfo();    
        }
    }

    private getUserRole() {
        this.userAPIService.hydrogenPortalApplicationRoles().subscribe(
            appRoles => {
                this.appRoles = appRoles;
                this.setUserRole();
            }
        );
    }

    private setUserInfo() {    
        this.userName = this.hydUser.LastName != null && this.hydUser.GivenName != null ? this.hydUser.LastName + ", " + this.hydUser.GivenName : "";
        this.userId = this.hydUser.UserId != null ? "(" + this.hydUser.UserId.substring(this.hydUser.UserId.indexOf("#") + 1) + ")" : "";        
    }

    private setUserRole() {
        let roleDisplayName : string = "";
        try {
            let appRole = this.appRoles.find(appRole => appRole.value === this.hydUser.Roles[0]);
            if (appRole)
                roleDisplayName = appRole.displayName;
        }
        catch(err) {}

        this.role = roleDisplayName;
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authentication/logout/logout.component.ts